export let listProps = {
    key: 0,
    id: 0,
    staff_id: 0,
    staff_name: '',
    absent: false,
    weekday_off: false,
    on_leave_id: 0,
    leave_name: '',
    holiday_id: 0,
    holiday_name: '',
    in_time: '',
    out_time: ''
}

export let dataProps = {
    entry_date: new Date(), 
    store_id: null,
    list: []
}


// WEBPACK FOOTER //
// ./src/store/modules/attendanceEntry/properties.js